/* eslint react/jsx-key: off */
import React from 'react';
import {
    Edit,
    FormTab,
    SaveButton,
    TabbedForm,
    NumberInput,
    DateInput,
    SelectInput,
    ReferenceInput,
    Toolbar,
    required,
} from 'react-admin';

import { dateFormatter, dateParser } from '../lib/date';

const PackageStockInEditToolbar = ({ permissions, ...props }) => (
    <Toolbar {...props}>
        <SaveButton
            label='resources.actions.save_and_show'
            redirect="show"
            submitOnEnter={true}
        />
        {permissions === 'admin' && (
            <SaveButton
                label='resources.actions.save_and_next'
                redirect={false}
                submitOnEnter={false}
                variant="flat"
            />
        )}
    </Toolbar>
);


const PackageStockInEdit = function({ permissions, ...props }) {

    return (
    <Edit {...props}>
        <TabbedForm toolbar={<PackageStockInEditToolbar permissions={permissions} />}>
            <FormTab label="resources.packagestockins.form.summary" path="">
                <ReferenceInput source="purchaseId" reference="purchases" perPage={100} validate={required()} label="resources.packagestockins.fields.purchase">
                    <SelectInput optionText="name" />
                </ReferenceInput>

                <ReferenceInput source="packageId" reference="packages" perPage={100} validate={required()} label="resources.packagestockins.fields.package">
                    <SelectInput optionText="name" />
                </ReferenceInput>

                <NumberInput
                    source="qty"
                    validate={required()}
                />
                <DateInput
                    source="stockInDate"
                    label="resources.packagestockins.fields.stockInDate"
                    format={dateFormatter} parse={dateParser}
                />
                <SelectInput source="warehouse" choices={[
                    { id: 'china', name: 'China' },
                    { id: 'stl', name: 'STL' },
                ]} validate={required()} />

                
                <ReferenceInput source="appUserId" reference="appusers" validate={required()} label="resources.packagestockins.fields.user">
                    <SelectInput optionText="username" />
                </ReferenceInput>
            </FormTab>
        </TabbedForm>
    </Edit>
    )
};

export default PackageStockInEdit;
